<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ type === 'image' ? 'Select Images' : 'Select Videos' }}</h3>
      <button class="close-btn" (click)="onClose()">×</button>
    </div>

    <div class="modal-body">
      <!-- Upload Drop Zone -->
      <div
        class="upload-zone"
        [class.dragging]="isDragging"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="triggerFileInput()"
      >
        <input
          type="file"
          id="media-file-input"
          [accept]="type === 'image' ? 'image/*' : 'video/*'"
          multiple
          hidden
          (change)="onFileSelected($event)"
        />
        <div class="upload-content">
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
          <p *ngIf="!isUploading">
            Drag & drop {{ type === 'image' ? 'images' : 'videos' }} here or
            click to upload
          </p>
          <p *ngIf="isUploading" class="uploading">Uploading...</p>
        </div>
      </div>

      <div class="media-grid" *ngIf="type === 'image'">
        <div
          *ngFor="let image of images"
          class="media-item"
          [class.selected]="isSelected(image.id)"
          (click)="toggleSelection(image.id)"
        >
          <img [src]="getMediaUrl(image)" alt="Image thumbnail" />
          <button
            class="delete-btn"
            (click)="onDeleteClick($event, image)"
            title="Delete image"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path
                d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
              ></path>
            </svg>
          </button>
          <div class="selection-indicator" *ngIf="isSelected(image.id)">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
        </div>

        <div *ngIf="images.length === 0" class="empty-state">
          <p>No images available</p>
          <p class="hint">Drag & drop images above to upload</p>
        </div>
      </div>

      <div *ngIf="type === 'video'" class="media-grid">
        <div
          *ngFor="let video of videos"
          class="media-item"
          [class.selected]="isSelected(video.id)"
          (click)="onVideoClick(video)"
        >
          <img [src]="getThumbnailUrl(video)" alt="Video thumbnail" />

          <button
            class="delete-btn"
            (click)="onDeleteClick($event, video)"
            title="Delete video"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path
                d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
              ></path>
            </svg>
          </button>
          <div class="selection-indicator" *ngIf="isSelected(video.id)">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="3"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </div>
        </div>

        <div *ngIf="videos.length === 0" class="empty-state">
          <p>No videos available</p>
          <p class="hint">Drag & drop videos above to upload</p>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="secondary" (click)="onClose()">Discard</button>
      <button class="primary" (click)="onSubmit()">Submit</button>
    </div>
  </div>
</div>

<!-- Delete Confirmation Dialog -->
<div
  class="confirmation-overlay"
  *ngIf="showDeleteConfirmation"
  (click)="cancelDelete()"
>
  <div class="confirmation-dialog" (click)="$event.stopPropagation()">
    <h4>Delete Image</h4>
    <p>
      Are you sure you want to delete this image? This action cannot be undone.
    </p>
    <div class="confirmation-actions">
      <button class="secondary" (click)="cancelDelete()">Cancel</button>
      <button class="danger" (click)="confirmDelete()">Delete</button>
    </div>
  </div>
</div>

<!-- Media Preview Modal -->
<!-- <nw-media-preview-modal
  [videoInstance]="previewVideoInstance"
  (close)="onVideoCancelled()"
  (videoSaved)="onVideoSaved($event)"
></nw-media-preview-modal> -->
